export default "__VITE_ASSET__CJOfN_E6__"